
import { AILoggingMessage, AILoggingSearch, AiLoggingService, LoggingMessage, LoggingSearch, LoggingService } from "@nt-portal/server-sdk";
import { BaseClientService } from "../base-client.service";
import { ControllerOptions, DataController } from "../../../types";


export interface AILoggingOptions extends ControllerOptions<AILoggingMessage> {
    filter?: AILoggingSearch
}


export class ClientAILoggingService extends BaseClientService implements DataController<AILoggingMessage> {

    private _service: AiLoggingService;


    constructor() {
        super();
        this._service = new AiLoggingService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async get(options: AILoggingOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }


    public async getById(options: AILoggingOptions) {
        if (options.id)
            return await this._service.getById(options.id, this.token);
        return null
    }


    public async add(options: AILoggingOptions) {
        if (options.item)
            return await this._service.add(options.item, this.token);
        return null;
    }
    public async delete(options: AILoggingOptions) {
        if (options.id)
            return await this._service.delete(options.id, this.token);
    }
}


